// extracted by mini-css-extract-plugin
module.exports = {"dimension":"DimensionLeaf_dimension__VJhvT","topRow":"DimensionLeaf_topRow__2Xu-H","verticalAlignmentWrapper":"DimensionLeaf_verticalAlignmentWrapper__7A4Fh"};